import {BaseModel} from "../../../../infrastructure/models/base-model";
import {GameCardAssetsRequestParams} from "../assets/game-card-assets.request-params";

export class GameCardIconModel extends BaseModel {
  icon: GameCardAssetsRequestParams;
  tooltipTitle: string;

  constructor(icon, tooltipTitle){
    super();

    this.icon = icon;
    this.tooltipTitle = tooltipTitle;
  }
}
